import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, Transition as _Transition } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "h5" }, " Project tags ", -1 /* HOISTED */)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "mb-48"
}
const _hoisted_5 = { class: "a6-12 d6-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "h5" }, " Add tags ", -1 /* HOISTED */)
const _hoisted_7 = { class: "form__set mb-16" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "new_tag",
  class: "form__label"
}, " Enter a tag ", -1 /* HOISTED */)
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "error-message"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (!$data.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            ($props.project.project_tags?.length)
              ? (_openBlock(), _createBlock(_TransitionGroup, {
                  key: 0,
                  name: "grid",
                  tag: "ul",
                  class: "tags mb-48"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.project.project_tags, (tag) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: tag.id,
                        class: "tags__tag tags__tag--selected"
                      }, [
                        _createTextVNode(_toDisplayString(tag.title) + " ", 1 /* TEXT */),
                        _createElementVNode("button", {
                          class: "tags__remove-tag",
                          onClick: $event => ($options.removeTag( tag.id ))
                        }, null, 8 /* PROPS */, _hoisted_3)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }))
              : (_openBlock(), _createElementBlock("p", _hoisted_4, " No suggested tags found. ")),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  id: "new_tag",
                  ref: "new-tag-input",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.new_tag) = $event)),
                  class: "form__input form__input--lowercase",
                  type: "text",
                  name: "new_tag",
                  disabled: $data.loading_tag,
                  onKeyup: _cache[1] || (_cache[1] = _withKeys((...args) => ($options.submitNewTag && $options.submitNewTag(...args)), ["enter"]))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9), [
                  [_vModelText, $data.new_tag]
                ])
              ]),
              _createElementVNode("button", {
                class: _normalizeClass(["button mb-16", { 'button--loading': $data.loading_tag }]),
                disabled: !$data.new_tag || $data.loading_tag,
                onClick: _cache[2] || (_cache[2] = (...args) => ($options.submitNewTag && $options.submitNewTag(...args)))
              }, " Create tag ", 10 /* CLASS, PROPS */, _hoisted_10),
              ($data.error_message)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString($data.error_message), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 1 }))
    ]),
    _: 1 /* STABLE */
  }))
}